import { useQuery } from '@tanstack/react-query';

import { verificationsControllerGetPlaidVerificationLinkToken } from '@/api/core-api';
import { getClient } from '@/utils/get-api-client';

import { queryKeys } from './query-keys';

export function usePlaidVerificationLinkToken(
  userId: string,
  projectId?: string,
) {
  return useQuery({
    queryKey: queryKeys.plaidVerificationLinkToken.byUserId(userId, projectId),
    queryFn: async () => {
      const response =
        await verificationsControllerGetPlaidVerificationLinkToken({
          client: getClient(userId),
          query: projectId ? { projectId } : undefined,
        });

      if (response.error || !response.data) {
        throw new Error('Failed to get Plaid verification token');
      }

      return response.data;
    },
  });
}
